import React from "react";
import PropTypes from "prop-types";
import Select from "react-select";
import { FormControl } from "react-bootstrap";

import Loader from "../../common/Loader";

import Controls from "./Controls";

import { RS_THEME } from "../DropdownSearch";
import Instructions from "./Instructions";

const TimePlannerControls = ({
  view,
  options,
  auth,
  loading,
  goToToday,
  handleChangeDate,
  toggleView,
  handlePrev,
  handleNext,
  selectedDate,
  handleZoomIn,
  handleZoomOut
}) => (
  <div className="timeplanner-controls-wrapper">
    <div className="time-planner-controls">
      <Controls
        handlePrev={handlePrev}
        handleNext={handleNext}
        zoomIn={handleZoomIn}
        zoomOut={handleZoomOut}
      />
    </div>
    {/* <div className="time-planner-controls">
      <div className="timeplanner-control-group">
        {!!selected.length && <span>{selected.length} Selected</span>}
      </div>
    </div> */}
    <div className="time-planner-controls">
      <div className="timeplanner-control-group loading">
        <Loader size={16} loading={loading} />
      </div>
    </div>
    <div className="time-planner-controls">
      <div className="timeplanner-control-group">
        <FormControl
          style={{ height: 38, padding: 5 }}
          className="timeplanner-control-group select"
          type="date"
          value={selectedDate}
          onChange={handleChangeDate}
        />
      </div>
      <Select
        name="view-select"
        placeholder="Select view"
        className="timeplanner-control-group select"
        options={options}
        value={view}
        isSearchable={false}
        isMulti={false}
        onChange={toggleView}
        theme={(theme) =>
          auth.isNightMode
            ? {
                ...theme,
                ...RS_THEME.DARK
              }
            : {
                ...theme,
                ...RS_THEME.LIGHT
              }
        }
      />
      <div className="timeplanner-control-group">
        <button className="btn btn-blue" onClick={goToToday}>
          Today
        </button>
      </div>
      <Instructions auth={auth} />
    </div>
  </div>
);

TimePlannerControls.propTypes = {
  view: PropTypes.object,
  options: PropTypes.array,
  auth: PropTypes.object,
  loading: PropTypes.bool,
  goToToday: PropTypes.func,
  handleChangeDate: PropTypes.func,
  toggleView: PropTypes.func,
  handlePrev: PropTypes.func,
  handleNext: PropTypes.func,
  selectedDate: PropTypes.string,
  handleZoomIn: PropTypes.func,
  handleZoomOut: PropTypes.func
};

export default TimePlannerControls;
